// extracted by mini-css-extract-plugin
export default {"wrapper":"textCellEditor_wrapper__WQXf6"};